import React from "react";
import {
  faBookOpenCover,
  faList,
  faBrowser,
    faVial
} from "@fortawesome/pro-light-svg-icons";
import { IconProp } from "@fortawesome/fontawesome-svg-core";
import { Card } from "../components/Card";
import {DOCS_SAMPLE_PREPARATION_ROUTE, ORDERS_ROUTE, TUTORIAL_ROUTE} from "../Routes";

export const Overview: React.FC = () => {
  return (
    <div className="container">
      <div className="row row-cols-1 row-cols-md-2 row-cols-xl-4 gy-40">
        <div className="col">
          <Card
              title="Tutorial"
              text="A quick introduction to our platform, including an upload guide for both supported MALDI-TOF formats"
              linkTo={TUTORIAL_ROUTE}
              isExternal={true}
              icon={faBookOpenCover as IconProp}
          />
        </div>
        <div className="col">
          <Card
              title="Sample Prep"
              text="Learn more about the recommended sample preparation protocols for different specimen types to ensure optimal identification results"
              linkTo={DOCS_SAMPLE_PREPARATION_ROUTE}
              icon={faVial as IconProp}
          />
        </div>
        <div className="col">
          <Card
              title="Orders"
              text="View the status and details of your previous and current orders"
              linkTo={ORDERS_ROUTE}
              icon={faList as IconProp}
          />
        </div>
        <div className="col">
          <Card
              title="Website"
              text="Find out more about the mabritecCentral database and the team of experts responsible for continually updating it"
              linkTo="https://mabriteccentral.com/"
              isExternal={true}
              icon={faBrowser as IconProp}
          />
        </div>
      </div>
    </div>
  );
};
